// extracted by mini-css-extract-plugin
module.exports = {"header":"getting-started-header_header__1zSwR"};